import React, { ReactElement } from 'react';
import { Route, HashRouter as Router } from 'react-router-dom';
import Home from './pages/home';
import Detail from './pages/detail'

const App = (): ReactElement => {
  return (
    <Router>
      <Route path="/" exact component={Home} />
      <Route path="/detail" exact component={Detail} />
    </Router>
  );
};

export default App;
